import type { SVGProps } from "react";

export function IconBlackStorefrontAlt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 2.25H21.75V8H21.75C21.75 8.72934 21.4602 9.42881 20.9445 9.94454C20.4288 10.4603 19.7293 10.75 18.9999 10.75C18.2706 10.75 17.5711 10.4603 17.0553 9.94454C16.5476 9.43678 16.2589 8.75091 16.2501 8.03379L16.2502 8H16.2499H14.7502H14.7499L14.75 8.03379C14.7412 8.75091 14.4525 9.43678 13.9448 9.94454C13.429 10.4603 12.7295 10.75 12.0002 10.75C11.2708 10.75 10.5713 10.4603 10.0556 9.94454C9.53986 9.42881 9.25012 8.72934 9.25012 8H9.2501H7.75012H7.7501C7.7501 8.72934 7.46036 9.42881 6.94463 9.94454C6.4289 10.4603 5.72941 10.75 5.00005 10.75C4.27069 10.75 3.5712 10.4603 3.05547 9.94454C2.53973 9.42881 2.25 8.72934 2.25 8V2.25ZM2.25 11.2404V21.75H11.25V16.75H12.75V21.75H21.75V11.2403C20.9849 11.8898 20.011 12.25 18.9999 12.25C17.8727 12.25 16.7917 11.8022 15.9947 11.0052C15.8108 10.8213 15.6455 10.6224 15.5 10.4112C15.3546 10.6224 15.1893 10.8213 15.0054 11.0052C14.2084 11.8022 13.1273 12.25 12.0002 12.25C10.873 12.25 9.79198 11.8022 8.99494 11.0052C8.81099 10.8213 8.64564 10.6222 8.50011 10.4109C8.35458 10.6222 8.18923 10.8213 8.00528 11.0052C7.20824 11.8022 6.12723 12.25 5.00005 12.25C3.98902 12.25 3.01514 11.8898 2.25 11.2404Z"
        fill="#23232C"
      />
    </svg>
  );
}
